import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {

  model = {
    'table_name': 'company', 'company_id': '0', 'company_name': '', 'company_name_en': '', 'company_logo': '', 'company_email': '',
    'company_resp': '', 'resp_mobile': '', 'company_tel1': '', 'company_tel2': '', 'country_id': '', 'city_id': '',
    'company_address': '', 'company_cr': '', 'company_tax_no': '', 'comment': ''
  };

  country = [];
  all_city = [];
  city = [];

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<CompanyComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;

    let query;
    let obj;

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.country = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });
  }

  getCity() {
    this.city = [];
    this.all_city.forEach(element => {
      if (element.country_id == this.model['country_id'])
        this.city.push(element);
    });
  }

  add() {
    if (this.model['company_name'] != '') {
      delete this.model['country_id'];
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['company_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'company_id': this.model['company_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
    else if (this.model['company_name'] == '') {
      alert("الرجاء إدخال  اسم الشركة");
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}

